import { Module } from "../plugins/_application";

var $ = jQuery;

export default class Employees extends Module {

	ready(app) {

		$(document).on('click', '.overview .link-wrap a', function(e) {

		    var thisHref = $(this).attr('href');

		    e.preventDefault();

		    $('html,body').animate({
		        scrollTop:$(thisHref).offset().top - 100
		    }, 500);
		});

    }
}